import { render } from "./zhudanbeifen.vue?vue&type=template&id=59a0cdda&scoped=true"
import script from "./zhudanbeifen.vue?vue&type=script&lang=js"
export * from "./zhudanbeifen.vue?vue&type=script&lang=js"

import "./zhudanbeifen.vue?vue&type=style&index=0&id=59a0cdda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a0cdda"]])

export default __exports__